import Model from 'src/app/core/models/model';

export default class PondTypeModel extends Model {
  id: string;
  name: string;
  isBH: number;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  
  constructor() {
    super();
  }
}
